import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type PostSuppliersRelevancePayload } from './types';

/**
 * Marks a supplier as relevant or irrelevant for the current user's organisation.
 *
 * @param payload - The data exchange ID and the desired relevance flag.
 * @param options - Optional ky request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-overview/operation/post_suppliers_relevance_suppliers_views_relevance_post
 */
export const postSuppliersRelevance = async (
  payload: PostSuppliersRelevancePayload,
  options?: KyRequestOptions,
) => {
  await vestigasApi
    .post(ENDPOINT.SUPPLIER.POST_RELEVANCE(), {
      json: payload,
      ...options,
    })
    .json();
};
